import Vue from 'vue'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en' // lang i18n

import '@/styles/index.scss' // global css
import '@/styles/public/public.scss'
import './styles/fundList/public.scss'
import './assets/fontFamily/font.css'

import App from './App'
import store from './store'
import router from './router'

import '@/icons' // icon
import '@/permission' // permission control
import './components/byComponents/themeCss/index.scss';
import ByComponents from './components/byComponents/installComponent.js'
Vue.use(ByComponents)

import ByPublic from "./views/public/installPublic.js"
Vue.use(ByPublic);
import directives from '../src/ask/directives/index.js'
Vue.use(directives)
import util from './utils/util'
Vue.use(util)


import * as filters from './filters' // 过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

import * as config from './api/config' // 过滤器
//let ApiMode = getBy56Api(env || process.env.NODE_ENV || 'dev');
let ApiMode = config.getBy56Api('prod');

Object.keys(ApiMode).forEach((v) => {
  Vue.prototype['$' + v] = ApiMode[v]
})

// set ElementUI lang to EN
//Vue.use(ElementUI, { locale })
// 如果想要中文版 element-ui，按如下方式声明
Vue.use(ElementUI)

Vue.config.productionTip = false

//全局组件
// input输入框
import Cascader from "./views/public/Cascader/Cascader.vue";
// input输入框--联级样式
import CascaderPanel from "./views/public/Cascader/Cascader-panel.vue";
// input输入框--搜索样式
import SeachPanel from "./views/public/Cascader/Seach-panel.vue";
// tabs 标签
import tabsItem from "./components/tabsList/tabsItem.vue";
Vue.component("Cascader", Cascader);
Vue.component("CascaderPanel", CascaderPanel);
Vue.component("SeachPanel", SeachPanel);
Vue.component("tabsItem", tabsItem);

// 防止el-button重复点击
Vue.directive('preventReClick', {
  inserted(el, binding) {
    el.addEventListener('click', () => {
      if (!el.disabled) {
        el.disabled = true
        setTimeout(() => {
          el.disabled = false
        }, binding.value || 2000)
      }
    })
  }
});
// router.beforeEach((to,from,next)=>{
// 	if(to.meta.title){
// 		console.log("路由=====",typeof to.meta.title==='function');
// 		if(typeof to.meta.title==='function'){
// 			document.title = to.meta.title(to.query)
// 		}else{
// 			document.title = to.meta.title;
// 		}
// 	}
// 	next()
// })
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
